export const MONITORING_INTERNAL_DATE_FORMAT = "YYYY-MM-DD";
